import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Constants } from '../shared/constants';
import { StorageService } from '../shared/services/storage.service';

@Injectable({
  providedIn: 'root'
})

export class HomeService {

  constructor(private http: HttpClient, private storageService: StorageService) { }

  // searchSpring POST Request
  // Headers added through HTTP Interceptor in the file shared/services/http-error.interceptor.service.ts
  getHomeHeroResponse(): Observable<any> {
    return this.http.get(`${Constants.searchSpringURL}/search/search.json?siteId=${Constants.searchSpringSiteId}&tag=home-page-v2&resultsFormat=native&resultsPerPage=100`);

  }


  // Get Featured Categories of logged in user from Jamestown GET Request
  getFeaturedCategories(paginationQuery?: string): Observable<any> {
    return this.http.get(`${Constants.baseURL}/featuredCategories`);
  }


  // Get Featured Guides of logged in user from Jamestown GET Request
  getFeaturedGuides(): Observable<any> {
    return this.http.get(`${Constants.baseURL}/featuredGuides`);
  }


}
